<template>
  <div class="hello">
    <el-row>
      <h1>{{ msg }}</h1>
    </el-row>
    <el-row>
      <el-carousel :interval="5000"
                   arrow="always">
        <el-carousel-item v-for="item in imgList"
                          :key="item.name">
          <img :src="item.src"
               style="height:100%;widht:100%;">
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <!-- <el-link href="http://support.autolink.top/Autolink.apk"
               type="primary"
               target="_blank">AutoLink 下载链接</el-link> -->
      <p>AutoLink官方版</p>
      <el-button onclick="window.location.href='http://support.autolink.top/Autolink.apk'"
                 type="success">安全下载</el-button>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <!-- <el-link href="http://support.autolink.top/Autolink_Pro.apk"
               type="primary"
               target="_blank">AutoLink pro 下载链接</el-link> -->
      <p>AutoLink pro官方版</p>
      <el-button onclick="window.location.href='http://support.autolink.top/Autolink_Pro.apk'"
                 type="success">安全下载</el-button>
    </el-row>
    <el-divider></el-divider>
    <div>
      <router-link to="/privacypolicy">Privacy Policy</router-link>
      <router-view></router-view>
    </div>
    <el-divider></el-divider>
    <el-row>
      <div>
        <p>
          版权所有 成都凌阳成芯科技有限公司
        </p>
        <p><a href="https://beian.miit.gov.cn"
             target="_blank">蜀ICP备13001769号-4</a></p>
      </div>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a target="_blank"
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004801"
           style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/assets/beian.png"
               style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">川公网安备 51019002004801号</p>
        </a>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '欢迎使用Autolink相关车载互联产品',
      imgList: [
        {
          name: 'bg1',
          src: require('@/assets/bg1.jpg')
        },
        {
          name: 'bg2',
          src: require('@/assets/bg2.jpg')
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue